import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FacetService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class HisenseFacetService extends FacetService {
  override getLinkParams(query: string): { [key: string]: string } {
    return {
      // to avoid encoding issues with facets that have space (' ') in their name,
      // we replace the decoded '+' back to empty space ' '.
      // For more, see https://github.com/SAP/spartacus/issues/7348
      query: new HttpUrlEncodingCodec().decodeValue(query.replace(/\+/g, ' ')),
    };
  }
}
